module.exports = __webpack_public_path__ + "img/goUP.3e6337c1.svg";